import { useState, useEffect, useContext } from "react";
import { reportFolioServices } from "../../../../../../../utils/constants/callService";
import { getAreaWithDepartments } from "../../../../../../../utils/methods/geServiceWithItemsFormat";
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals";
import { FormContext } from "../Context";
import { OptionsMostFrequentArray } from "../../../../../../../service/questionarie/response";
import { formatFrequentOptions } from "../../../../../../../service/reportFolio/format/options";

export const useGetData = () => {
  const [areas, setAreas] = useState<Item[]>([]);
  const [departments, setDepartments] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);
  const [unitys, setUnitys] = useState<Item[]>([]);
  const [questionnaires, setQuestionnaires] = useState<Item[]>([]);
  const [isAreasLoaded, setIsAreasLoaded] = useState(false);
  const [isOptionsLoaded, setIsOptionsLoaded] = useState(false);
  const [providers, setProviders] = useState<Item[]>([]);
  const { setConfig, config } = useContext(FormContext);
  const [options, setOptions] = useState<OptionsMostFrequentArray>([]);
  const [notOptions, setNotOptions] = useState(false)

  const fetchAreas = async () => {
    try {
      const response = await getAreaWithDepartments();
      setAreas(response);
      setIsAreasLoaded(true);
      return response;
    } catch (error) {
      console.error("Error fetching areas:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const fetchFrequentOptions = async () => {
    try {
      setIsOptionsLoaded(true)
      const response = await reportFolioServices.getFrequentOptions('preventive');
      if(!response.errors && response.length!=0){
        const {options} = formatFrequentOptions({response})
        setOptions(options);
      } else {
        setNotOptions(true)
      }
      
      return response;
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    } finally {
      setIsOptionsLoaded(false);
    }
  };

  const fetchUnitys = async () => {
    try {
      const response = await reportFolioServices.getUnitys();
      // Formatear las unidades para el CustomSelect
      //@ts-ignore
      const formattedUnitys = response.map((unity: any) => ({
        label: `${unity.name}`,
        value: unity.id,
        extraData: {
          email: unity.email,
          address: unity.address,
          phone: unity.phone,
          timeZone: unity.storeTimeZone,
          user: unity.user
        }
      }));
      setUnitys(formattedUnitys);
      return formattedUnitys;
    } catch (error) {
      console.error("Error fetching unitys:", error);
      return [];
    }
  }

  const fetQuestionnaires = async (id:number | string) => {
    try {
      const response = await reportFolioServices.getQuestionnaries({ type: false, user_assign_id:id });
      // Formatear las unidades para el CustomSelect
      //@ts-ignore
      const formattedQuestionnaries = response.map((questionnarie) => ({
        label: `${questionnarie.name}`,
        value: questionnarie.id,
      }));
      setQuestionnaires(formattedQuestionnaries);
      return formattedQuestionnaries;
    } catch (error) {
      console.error("Error fetching questionnaires:", error);
      return [];
    }
  }

  useEffect(() => {
    fetchAreas();
    fetchUnitys();
    //fetQuestionnaires();
  }, []);

  const loadDepartmentsByArea = async (selectedArea: ObjectGeneric) => {
    let currentAreas = areas;

    if (areas.length === 0) {
      currentAreas = await fetchAreas();
    }

    const area = currentAreas.find(area => Number(area.value) === Number(selectedArea.value));

    if (area && area.departments) {
      const areaDepartments: Item[] = area.departments.map((dept: { name: any; id: { toString: () => any; }; }) => ({
        label: dept.name,
        value: dept.id
      }));

      setDepartments(areaDepartments);
      return areaDepartments;
    } else {
      setDepartments([]);
      return [];
    }
  };

  const getCategoriesByDepartment = async (departmentId: string, type: string = 'preventive') => {
    try {
      const response = await reportFolioServices.getCategoriesByDepartment({ departmentId, type });
      return response;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return null;
    }
  }

  const getProvidersForUnit = async (storeId: string | number, departmentId: string | number, selectedProviderCopy?: Item) => {
    try {
      const response = await reportFolioServices.getProvidersToAssign({
        storeId,
        departmentId
      });

      // Formatear los proveedores para el CustomSelect
      const formattedProviders = response.map((provider: any) => ({
        label: `${provider.firstName} ${provider.lastName}`,
        value: provider.id
      }));

      const existsProvidder = formattedProviders.some((provider: any) => provider.value === selectedProviderCopy?.value);

      setProviders((selectedProviderCopy && !existsProvidder) ? [...formattedProviders,selectedProviderCopy] : formattedProviders );
      return formattedProviders;
    } catch (error) {
      console.error("Error fetching providers:", error);
      setProviders([]);
      return [];
    }
  };

  const getCorrectiveData = async (id:string) => {
    try {
      const response = await reportFolioServices.getCorrectiveData({ id });
      return response;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return null;
    }
  }

  const getConfig = async (areaId: string | number, departmentId: string | number) => {
    try {
      const response = await reportFolioServices.getConfigGeneral({
        areaId,
        departmentId
      });
      setConfig(response);
      if (response.errors) return []
      return response;
    } catch (error) {
      console.error("Error fetching config:", error);
      setConfig(null);
      return null;
    }
  };

  const createFolio = async (body: ObjectGeneric) => {
    const response = await reportFolioServices.createFolio(body)
    return response
  }

  const editFolio = async (body: ObjectGeneric,id:number) => {
    const response = await reportFolioServices.editionFolio(body,id)
    return response
  }

  return {
    areas,
    departments,
    loadDepartmentsByArea,
    loading,
    unitys,
    isAreasLoaded,
    getCategoriesByDepartment,
    getProvidersForUnit,
    providers,
    config,
    getConfig,
    createFolio,
    questionnaires,
    fetQuestionnaires,
    getCorrectiveData,
    editFolio,
    options,
    notOptions,
    isOptionsLoaded,
    fetchFrequentOptions
  };

};